import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const InboundRoute: Route = {
  path: 'inbound',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/inbound.component').then((m) => m.InboundComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
